<template>
  <el-input
    clearable
    :value="value"
    v-bind="$attrs"
    v-on="$listeners"
    :size="formSize"
  >
    <el-select
      slot="prepend"
      placeholder="请选择"
      style="min-width: 140px"
      v-model="selectValue"
      v-bind="$attrs.attrs"
      :size="formSize"
      :loading="loadingList"
      @change="change($event)"
    >
      <el-option
        v-for="item in selectOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </el-input>
</template>

<script>
export default {
  name: 'SearchInputSelect',
  props: {
    // 默认值
    value: {
      type: [Number, String, Array, Object],
    },
    // 搜索对象值
    searchObj: {
      type: Object,
      default: () => ({}),
    },
    // 其他参数项
    queryItem: {
      type: [Array, Object],
      default: () => ({
        key: '',
        value: '',
      }),
    },
    // 下拉选项
    options: {
      type: Array,
      default: () => ([]),
    },
    // 字段类型
    dictionaryType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loadingList: false,
    };
  },
  computed: {
    selectOptions() {
      // 如果有静态的options，就不通过接口获取
      if (this.options.length > 0) {
        return this.options || [];
      }
      const { dictData = {} } = this.$store.state.dictionary;
      return dictData[this.dictionaryType] || [];
    },
    selectValue: {
      get() {
        return this.searchObj[this.queryItem.key];
      },
      set() { },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { dictionaryType } = this;
      if (!dictionaryType) {
        console.log('没有字典');
      } else {
        // 获取字典
        this.loadingList = true;
        try {
          if (dictionaryType === '') return; // dictionaryType为空时,不请求
          this.$store.dispatch('dictionary/getDictionary', { type: dictionaryType });
        } finally {
          this.loadingList = false;
        }
      }
    },
    change(val) {
      const { key } = this.queryItem;
      this.$emit('setFormFields', { [key]: val });
    },
  },
};
</script>

